/* eslint-disable max-lines */
import React, { useCallback, useMemo } from 'react';
import { useSelector } from 'store';

import { setInlineCommentReference } from 'actions';
import { NEW_CHEVRON_LEFT } from 'constants/filterIcons';
import { useDispatch } from 'react-redux';
import { useParams } from 'react-router-dom';
import { getInlineCommentReference } from 'selectors/envelopeReview';
import { getSingleEnvelopeComments } from 'selectors/envelopes';
import { EnvelopeAction } from 'types';

const InlineCommentsNavigation: React.FC = () => {
  const dispatch = useDispatch();

  const { envelopeId } = useParams<{ envelopeId: string }>();

  const commentReference = useSelector(getInlineCommentReference);

  const commentsFilter = useCallback(
    (c: EnvelopeAction): boolean =>
      // @ts-ignore
      c.payload.lineIndex !== undefined &&
      // @ts-ignore
      c.payload.nodes?.[0] !== undefined &&
      // @ts-ignore
      c.payload.communicationId,
    []
  );

  const unfilteredComments = useSelector((state) => getSingleEnvelopeComments(state, envelopeId));
  const comments = useMemo(() => {
    if (commentsFilter) {
      return unfilteredComments.filter(commentsFilter);
    }
    return unfilteredComments;
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [unfilteredComments]);

  const references = comments
    .sort((a, b) => {
      // @ts-ignore
      if (a.payload.lineIndex < b.payload.lineIndex) return -1;
      // @ts-ignore
      if (a.payload.lineIndex > b.payload.lineIndex) return 1;
      // @ts-ignore
      if (a.payload.nodes[0] < b.payload.nodes[0]) return -1;
      // @ts-ignore
      if (a.payload.nodes[0] > b.payload.nodes[0]) return 1;
      // @ts-ignore
      if (a.payload.communicationId > b.payload.communicationId) return -1;
      return 1;
    })
    .reduce<EnvelopeAction[]>((acc, cur) => {
      const lastItem = acc[acc.length - 1];

      if (!lastItem) return [...acc, cur];

      const isSameReference =
        // @ts-ignore
        lastItem.payload.lineIndex === cur.payload.lineIndex &&
        // @ts-ignore
        lastItem.payload.nodes?.[0] === cur.payload.nodes?.[0] &&
        // @ts-ignore
        lastItem.payload.communicationId === cur.payload.communicationId;

      if (!isSameReference) {
        return [...acc, cur];
      }
      return acc;
    }, []);

  const currentCommentIndex = references.findIndex(
    (c) =>
      // @ts-ignore
      c.payload.lineIndex === commentReference.lineNumber &&
      // @ts-ignore
      c.payload.nodes?.[0] === commentReference.nodes[0] &&
      // @ts-ignore
      c.payload.communicationId === commentReference.communicationId
  );

  const handlePreviousMatch = (): void => {
    const prevComment = references[currentCommentIndex - 1];

    if (prevComment) {
      dispatch(
        setInlineCommentReference({
          // @ts-ignore
          communicationId: prevComment.payload.communicationId,
          // @ts-ignore
          lineNumber: prevComment.payload.lineIndex,
          // @ts-ignore
          nodes: prevComment.payload.nodes,
          text: '',
        })
      );
    }
  };

  const handleNextMatch = (): void => {
    const nextComment = references[currentCommentIndex + 1];

    if (nextComment) {
      dispatch(
        setInlineCommentReference({
          // @ts-ignore
          communicationId: nextComment.payload.communicationId,
          // @ts-ignore
          lineNumber: nextComment.payload.lineIndex,
          // @ts-ignore
          nodes: nextComment.payload.nodes,
          text: '',
        })
      );
    }
  };

  return (
    <div className="w-full px-4 flex flex-row gap-2 justify-end items-center bg-white">
      <span className="whitespace-no-wrap">
        {currentCommentIndex + 1} of {references.length}
      </span>
      <button
        type="button"
        className={`flex justify-center w-4 focus:outline-none ${
          currentCommentIndex === 0 ? 'opacity-50 cursor-default' : ''
        }`}
        onClick={handlePreviousMatch}
        disabled={currentCommentIndex === 0}
      >
        {NEW_CHEVRON_LEFT}
      </button>
      <button
        type="button"
        className={`flex justify-center w-4 transform rotate-180 focus:outline-none ${
          currentCommentIndex === references.length - 1 ? 'opacity-50 cursor-default' : ''
        }`}
        onClick={handleNextMatch}
        disabled={currentCommentIndex === references.length - 1}
      >
        {NEW_CHEVRON_LEFT}
      </button>
    </div>
  );
};
export default InlineCommentsNavigation;
